/* eslint-disable */
import MobxReactForm from 'mobx-react-form';
import dvr from 'mobx-react-form/lib/validators/DVR';
import validatorjs from 'validatorjs';
import { PHONE_PREFIXES, PHONE_PREFIX_DEFAULT } from '../../../../framework/constants/forms';
const plugins = {
    dvr: dvr({
        package: validatorjs
    })
};
export const fields = [{
        value: '',
        name: 'firstName',
        rules: 'required|string|firstName'
    }, {
        value: '',
        name: 'lastName',
        rules: 'required|string|lastName'
    }, {
        name: 'email',
        type: 'email',
        label: 'contactForm.email',
        rules: 'required|email',
        value: ''
    }, {
        name: 'phoneMain',
        label: 'contactForm.phoneMain',
        fields: [
            {
                name: 'countryCode',
                extra: PHONE_PREFIXES,
                value: PHONE_PREFIX_DEFAULT,
                rules: 'required',
                output: (data) => {
                    return data.value ? data.value : data;
                }
            },
            {
                name: 'areaCode',
                type: 'tel',
                rules: 'required|phone_areaCode'
            },
            {
                name: 'phoneNumber',
                type: 'tel',
                rules: 'required|phone_phoneNumber'
            }
        ],
        output: (value) => {
            const { countryCode, areaCode, phoneNumber } = value;
            return `${countryCode ? countryCode : ''}${areaCode}${phoneNumber}`;
        }
    }, {
        value: '',
        name: 'message',
        placeholder: 'contactForm.textPlaceholder',
        rules: 'required|string'
    }, {
        value: false,
        name: 'terms',
        type: 'checkbox',
        rules: 'boolean|accepted'
    }];
const hooks = {
    onError(form) {
        form.invalidate('This is a generic error message!');
    }
};
const options = {
    validateOnChange: true
};
export default new MobxReactForm({ fields }, { options, plugins, hooks });
/* eslint-enable */
